// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11108":"36fa5bf7","24184":"36fa5bf7","91568":"0f879c96","94191":"36fa5bf7"}[chunkId] + ".chunk.css";
};